import { approvalStateApi, individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initPrescreeningKyc({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchApprovalStates'),
      dispatch('fetchDetail', individualId),
      dispatch('fetchDilisense', individualId),
      dispatch('fetchDocuments', individualId),
      dispatch('fetchQuestionnaire', individualId),
      dispatch('fetchVideo', individualId),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchApprovalStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await approvalStateApi.requestAll(token);
      commit('setApprovalStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDetail({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDetail(token, individualId);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDilisense({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDilisense(
        token,
        individualId,
      );
      commit('setDilisense', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDocuments({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDocuments(
        token,
        individualId,
      );
      commit('setDocuments', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCddQuestionnaire(
        token,
        individualId,
      );
      commit('setQuestionnaire', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchVideo({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestVideo(token, individualId);
      commit('setVideo', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} individualId
   * @param {String} documentId
   * @param {Object} data
   */
  async approveDocument(
    { commit, dispatch, rootGetters },
    { individualId, documentId },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestApproveDocuments({ token, documentId });
      await dispatch('fetchDocuments', individualId);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} individualId
   * @param {String} videoId
   */
  async approveFacecheckVideo(
    { commit, dispatch, rootGetters },
    { individualId, videoId },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestApproveFacecheckVideo({
        token,
        videoId,
      });
      await dispatch('fetchVideo', individualId);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} individualId
   * @param {String} videoId
   */
  async approveFacecheckDocument(
    { commit, dispatch, rootGetters },
    { individualId, videoId },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestApproveFacecheckDocument({
        token,
        videoId,
      });
      await dispatch('fetchVideo', individualId);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} individualId
   * @param {Object} data
   */
  async saveDilisenseDocument(
    { commit, dispatch, rootGetters },
    { individualId, data },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestCreateDilisense({
        token,
        individualId,
        data,
      });
      await dispatch('fetchDilisense', individualId);
      return true;
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} documentId
   */
  async removeDilisenseDocument(
    { commit, dispatch, rootGetters },
    { documentId, individualId },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestDeleteDilisense(token, documentId);
      await dispatch('fetchDilisense', individualId);
      return true;
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   * @param {Object} data
   */
  async approveUser({ commit, rootGetters }, { individualId, data }) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestApproveProfile({ token, individualId, data });
      return true;
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
};
